<template>
  <div class="asc-flight-deck-effects">
    <div class="asc-flight-deck-effects--text">
      {{ getIntroText }}
    </div>
    <div class="asc-flight-deck-effects--grid">
      <asc-flight-deck-effects-grid
        :values="items"
        :grid-columns="gridColumns"
        :grid-filters="false"
      ></asc-flight-deck-effects-grid>
    </div>
    <div
      v-if="fleetPageFaultMessagePermission"
      class="asc-flight-deck-effects--button"
    >
      <asc-accent-button
        :button-text="getButtonText"
        block
        :on-click="onOpenFullFleet"
      ></asc-accent-button>
    </div>
  </div>
</template>

<script>
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscFlightDeckEffectsGrid from '@/components/molecules/AscFlightDeckEffectsGrid'
import { mapGetters } from 'vuex'
import { USER_CONSTS as UC } from '@/stores/consts'

export default {
  name: 'AscFlightDeckEffects',

  components: {
    AscAccentButton,
    AscFlightDeckEffectsGrid,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    fdeItem: {
      type: Object,
      default: () => {},
    },
    gridColumns: {
      type: Array,
      default: () => [],
    },
    onOpenFullFleet: {
      type: Function,
      default: () => {},
    },
  },

  computed: {
    getIntroText() {
      return `Review flight deck effects for ${this.fdeItem.name} on Flight ${this.fdeItem.fdeFlightNumber} ${this.fdeItem.fdeFormattedFlightStart}.`
    },

    getButtonText() {
      return `Analyze Fault Messages for ${this.fdeItem.name} and Full Fleet`
    },

    ...mapGetters(UC.NAMESPACE, ['fleetPageFaultMessagePermission']),
  },
}
</script>

<style lang="scss">
.asc-flight-deck-effects {
  &--text {
    margin-bottom: 24px;
  }

  &--grid {
    border: 1px solid $gray-300;
    padding: 16px;
  }

  &--button {
    margin: 24px 0;
  }
}
</style>
